/**
 * Big Waster API
 * This is a Big Waster API.
 *
 * OpenAPI spec version: 1.0
 * Contact: terry.wong@futureimpactlab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The WasterecordCreateRecordParam model module.
 * @module model/WasterecordCreateRecordParam
 * @version 1.0
 */
class WasterecordCreateRecordParam {
    /**
     * Constructs a new <code>WasterecordCreateRecordParam</code>.
     * @alias module:model/WasterecordCreateRecordParam
     */
    constructor() { 
        
        WasterecordCreateRecordParam.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>WasterecordCreateRecordParam</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/WasterecordCreateRecordParam} obj Optional instance to populate.
     * @return {module:model/WasterecordCreateRecordParam} The populated <code>WasterecordCreateRecordParam</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new WasterecordCreateRecordParam();

            if (data.hasOwnProperty('bagType')) {
                obj['bagType'] = ApiClient.convertToType(data['bagType'], 'String');
            }
            if (data.hasOwnProperty('date')) {
                obj['date'] = ApiClient.convertToType(data['date'], 'String');
            }
            if (data.hasOwnProperty('metal')) {
                obj['metal'] = ApiClient.convertToType(data['metal'], 'Number');
            }
            if (data.hasOwnProperty('paper')) {
                obj['paper'] = ApiClient.convertToType(data['paper'], 'Number');
            }
            if (data.hasOwnProperty('plastic')) {
                obj['plastic'] = ApiClient.convertToType(data['plastic'], 'Number');
            }
            if (data.hasOwnProperty('scheduleId')) {
                obj['scheduleId'] = ApiClient.convertToType(data['scheduleId'], 'Number');
            }
            if (data.hasOwnProperty('userId')) {
                obj['userId'] = ApiClient.convertToType(data['userId'], 'Number');
            }
            if (data.hasOwnProperty('waste')) {
                obj['waste'] = ApiClient.convertToType(data['waste'], 'Number');
            }
        }
        return obj;
    }


}

/**
 * @member {String} bagType
 */
WasterecordCreateRecordParam.prototype['bagType'] = undefined;

/**
 * @member {String} date
 */
WasterecordCreateRecordParam.prototype['date'] = undefined;

/**
 * @member {Number} metal
 */
WasterecordCreateRecordParam.prototype['metal'] = undefined;

/**
 * @member {Number} paper
 */
WasterecordCreateRecordParam.prototype['paper'] = undefined;

/**
 * @member {Number} plastic
 */
WasterecordCreateRecordParam.prototype['plastic'] = undefined;

/**
 * @member {Number} scheduleId
 */
WasterecordCreateRecordParam.prototype['scheduleId'] = undefined;

/**
 * @member {Number} userId
 */
WasterecordCreateRecordParam.prototype['userId'] = undefined;

/**
 * @member {Number} waste
 */
WasterecordCreateRecordParam.prototype['waste'] = undefined;






export default WasterecordCreateRecordParam;

